import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

// Import styles
import {
	transitionMain,
	customMinResponsive,
	flex,
	media,
	size
} from 'components/styles';

export const StyledLink = styled(Link)`
	color: ${({ theme }) => theme.blueAzureDark};
	cursor: pointer;
	${transitionMain}
	font-size: 2.5rem;

	&:hover {
		color: ${({ theme }) => theme.white};
	}
`;

export const Comma = styled.span`
	color: ${({ theme }) => theme.blueAzureDark};
	font-size: 2.5rem;
`;

export const ButtonWrapper = styled.div`
	width: 22rem;
	margin: 0 auto;

	${customMinResponsive(
		size.semi,
		css`
			width: auto;
		`
	)}
`;

export const Wrapper = styled.div`
	width: 90%;
	${flex()};
	flex-direction: column;
	margin: 0 auto;
	${media.min.xmin(css`
		margin: 3.7rem auto;
		width: 61rem;
	`)}
`;

export const Paragraph = styled.p`
	text-align: center;
	letter-spacing: 0.4px;
	font-size: 1.4rem;
	font-weight: ${({ theme }) => theme.font.light};
	color: ${({ theme }) => theme.white};
	opacity: 0.4;
	line-height: 1.25em;

	${media.min.xmin(css`
		font-size: 2rem;
		letter-spacing: 0.63px;
		line-height: 1.5em;
	`)}
	${media.min.min(css`
		font-size: 3rem;
	`)}
`;
